import styles from './new-label.module.css';

const NewLabel = () => {
  return (
    <div className={styles.root}>New</div>
  );
};

export default NewLabel;
